<template>
    <div class="relative hema-div">
        <div class="account_card_container">
            <div class="clearfix pt-4">
                <div class="account_card_avatar">
                    <img :src="avatar" alt="avatar">
                    <template v-if="parentId">
                        <span v-if="isBlocked">
                            <span class="status-icon blocked"></span>
                        </span>
                        <span v-else>
                            <span v-if="invitationStatus" class="status-icon approved"></span>
                            <span v-else class="status-icon pending"></span>
                        </span>
                    </template>
                </div>
                <div class="account_card_details">
                    <h5>
                        <span class="account-name">{{name}}</span>
                        <template v-if="showParent && parentId">
                            <span class="link go-to-sub-account-details" v-if="invitationStatus && $can('view_sub_account')" :data-id="id">View</span>
                            <span class="link resend-invitation" v-else-if="$can('invite_sub_account')" :data-id="id">Resend</span>
                        </template>
                    </h5>
                    <p class="email mt-6">{{email}}</p>
                    <p class="accounts_num " v-if="false">{{accountsNum}} subaccounts</p>
                </div>
            </div>
            <button class="account_card_invite absolute" v-if="invitationStatus && $can('invite_sub_account')" :data-id="id">+</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'account-card',
  props: ['name', 'email', 'accountsNum', 'invitationStatus', 'avatar', 'parentId', 'id', 'showParent', 'isBlocked']
}
</script>

<style lang="scss">
.account_card_container,
.account_card_container * {
  padding: 0;
  margin: 0;
  border-spacing: 0;
}

.account_card_container {
  position: relative;
  min-width: 444px;
  min-height: 130px;
  padding: 15px !important;

  .account_card_avatar {
    width: 80px;
    height: 80px;
    float: left;
    position: relative;
    margin-right: 10px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    .status-icon {
      display: inline-block;
      position: absolute;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      bottom: 5px;
      right: 5px;
      border: 1px solid #fff;
    }

    .approved {
      background: rgb(45, 205, 122);
    }

    .pending {
      background: #f2af03;
    }

    .blocked {
      background: #db2827;
    }
  }

  .account_card_details {
    text-align: left;
    min-width: 200px;

    h5 {
      padding-top: 5px;
      margin-bottom: 10px;
      color: #2c2c2c;

      .link {
        float: right;
        font-size: 14px;
        cursor: pointer;
        color: #0092d7;
        line-height: 21px;
      }
    }

    .account-name {
      font-size: 18px !important;
      letter-spacing: 0.107143px;
      line-height: 27px;
      color: #2c2c2c;
    }

    .email {
      margin-bottom: 5px;
      color: #2c2c2c;
      font-size: 14px !important;
      line-height: 21px;
      letter-spacing: 0.107143px;
    }

    .accounts_num {
      color: rgba(44, 44, 44, 0.4);
    }
  }

  .account_card_invite {
    background: #0092d7;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: white;
    font-weight: bold;
    font-size: 20px;
    cursor: pointer;
    border: 0;
    position: absolute;
    left: 49%;
    margin-left: -15px;
    top: 96%;
    padding-top: 3px;
    display: flex;
    align-items: center !important;
    justify-content: center;
    top: 82%;
  }
}
</style>
